import { Component } from '@angular/core';

@Component({
    selector: 'app-survey-complete',
    standalone: true,
    templateUrl: './survey-complete.component.html'
})
export class SurveyCompleteComponent {

}
